import { Api } from "./Api";
import { FactureFournisseur } from "../models/FactureFournisseur";
import _ from "lodash";

export class FactureFournisseurApi extends Api {
    constructor() {
        super("document/facture-fournisseur");
    }

    getAll(params?: Object): Promise<Api.CallResponse> {
        return this.getResources(params).then(function (response) {
            let res: Array<FactureFournisseur> = [];
            if (response.data && response.data.data) {
                res = _.map(response.data.data, function (f) {
                    return new FactureFournisseur(f);
                });
            }
            return {
                data: res,
                metadata: response.data.metadata,
                paginator: response.data.paginator,
            };
        });
    }

    get(id: Number, params?: Object): Promise<FactureFournisseur> {
        return this.getResource(id, params).then(function (response) {
            return new FactureFournisseur(response.data.data);
        });
    }

    save(factureFournisseur: FactureFournisseur, params?: Object): Promise<FactureFournisseur> {
        return super
            .saveResource(factureFournisseur.serialize(), params)
            .then(function (response) {
                return new FactureFournisseur(response.data.data);
            });
    }

    delete(id: Number, raison: string): Promise<FactureFournisseur> {
        return super.deleteResource(id, raison).then(function (response) {
            return new FactureFournisseur(response.data.data);
        });
    }
}
